module.exports = __webpack_public_path__ + "assets/images/TTD5.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/TTD5.png
// module id = 1436
// module chunks = 1